module.exports = __webpack_public_path__ + "static/liva-web-b730b9052805bf70d99b932a369f54d0.jpg";